/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRepoStatus.defs.js'
export * as $defs from './getRepoStatus.defs.js'
